import * as React from "react"
import styled from 'styled-components/macro'
import DolomiteDevicesHeaderImage from '../../images/borrow-page.png'
import DolomiteDevicesHeaderImageBlurred from '../../images/borrow-page-blurred.png'
import {keyframes} from "styled-components";
import AnimatedNumbers from "react-animated-numbers";
import {useEffect, useState} from "react";
import { Link } from "gatsby"
import Ticker from 'react-ticker'
import ANTLogo from '../../images/markets/ANT.png'
import ARBLogo from '../../images/markets/ARB.svg'
import BATLogo from '../../images/markets/BAT.png'
import BERALogo from '../../images/markets/BERA.svg'
import BNTLogo from '../../images/markets/BNT.png'
import DAILogo from '../../images/markets/DAI.png'
import DPXLogo from '../../images/markets/DPX.svg'
import ETHLogo from '../../images/markets/ETH.svg'
import EzETHLogo from '../../images/markets/ezETH.svg'
import FBTCLogo from '../../images/markets/FBTC.svg'
import GLPLogo from '../../images/markets/GLP.png'
import GmARBLogo from '../../images/markets/ARB-GM.svg'
import GmBTCLogo from '../../images/markets/WBTC-GM.svg'
import GmETHLogo from '../../images/markets/ETH-GM.svg'
import GmLINKLogo from '../../images/markets/LINK-GM.svg'
import GmUNILogo from '../../images/markets/UNI-GM.svg'
import GMXLogo from '../../images/markets/GMX.svg'
import GRAILogo from '../../images/markets/GRAI.svg'
import GRAILLogo from '../../images/markets/GRAIL.svg'
import HONEYLogo from '../../images/markets/HONEY.svg'
import JONESLogo from '../../images/markets/JONES.svg'
import jUSDCLogo from '../../images/markets/jUSDC.svg'
import KNCLogo from '../../images/markets/KNC.png'
import LINKLogo from '../../images/markets/LINK.png'
import LRCLogo from '../../images/markets/LRC.png'
import MAGICLogo from '../../images/markets/MAGIC.svg'
import MATICLogo from '../../images/markets/MATIC.svg'
import MagicGLPLogo from '../../images/markets/mGLP-dual-logo.svg'
import METHLogo from '../../images/markets/mETH.svg'
import MIMLogo from '../../images/markets/MIM.svg'
import MNTLogo from '../../images/markets/MNT.svg'
import OKBLogo from '../../images/markets/OKB.svg'
import PENDLELogo from '../../images/markets/PENDLE.svg'
import plvGLP from '../../images/markets/plvGLP.svg'
import PREMIALogo from '../../images/markets/PREMIA.svg'
import PTezETHLogo from '../../images/markets/PT-ezETH.svg'
import PTGLPLogo from '../../images/markets/PT-GLP.svg'
import PTmETHLogo from '../../images/markets/PT-mETH.svg'
import PTrETHLogo from '../../images/markets/PT-rETH.svg'
import PTrsETHLogo from '../../images/markets/PT-rsETH.svg'
import PTUSDeLogo from '../../images/markets/PT-USDe.svg'
import PTweETHLogo from '../../images/markets/PT-weETH.svg'
import PTwstETHLogo from '../../images/markets/PT-wstETH.svg'
import PTSILogo from '../../images/markets/PTSI.svg'
import RDNTLogo from '../../images/markets/RDNT.svg'
import REPLogo from '../../images/markets/REP.png'
import rETHLogo from '../../images/markets/rETH.svg'
import rsETHLogo from '../../images/markets/rsETH.svg'
import sMNTLogo from '../../images/markets/sMNT.svg'
import UNILogo from '../../images/markets/UNI.svg'
import USDCLogo from '../../images/markets/USDC.svg'
import USDeLogo from '../../images/markets/USDe-alt.svg'
import USDMLogo from '../../images/markets/USDM.svg'
import USDTLogo from '../../images/markets/USDT.png'
import USDYLogo from '../../images/markets/USDY.svg'
import WBERALogo from '../../images/markets/wBERA.svg'
import WBTCLogo from '../../images/markets/WBTC.png'
import WETHLogo from '../../images/markets/WETH.png'
import weETHLogo from '../../images/markets/weETH.svg'
import WMATICLogo from '../../images/markets/WMATIC.png'
import WMNTLogo from '../../images/markets/WMNT.svg'
import wOETHLogo from '../../images/markets/WOETH.svg'
import WOKBLogo from '../../images/markets/WOKB.svg'
import wstETHLogo from '../../images/markets/wstETH.svg'
import wUSDMLogo from '../../images/markets/wUSDM.svg'
import XAILogo from '../../images/markets/XAI.svg'
import ZRXLogo from '../../images/markets/ZRX.png'

import UNKNOKWNLogo from '../../images/dolomite-symbol-white.svg'

const logos = {
  ANT: ANTLogo,
  ARB: ARBLogo,
  BAT: BATLogo,
  BERA: BERALogo,
  BNT: BNTLogo,
  DAI: DAILogo,
  DPX: DPXLogo,
  ETH: ETHLogo,
  ezETH: EzETHLogo,
  FBTC: FBTCLogo,
  GLP: GLPLogo,
  gmARB: GmARBLogo,
  'gmARB-USD': GmARBLogo,
  gmBTC: GmBTCLogo,
  'gmBTC-USD': GmBTCLogo,
  gmETH: GmETHLogo,
  'gmETH-USD': GmETHLogo,
  gmLINK: GmLINKLogo,
  'gmLINK-USD': GmLINKLogo,
  'gmUNI-USD': GmUNILogo,
  GMX: GMXLogo,
  GRAI: GRAILogo,
  GRAIL: GRAILLogo,
  HONEY: HONEYLogo,
  JONES: JONESLogo,
  jUSDC: jUSDCLogo,
  KNC: KNCLogo,
  LINK: LINKLogo,
  LRC: LRCLogo,
  MAGIC: MAGICLogo,
  MATIC: MATICLogo,
  mETH: METHLogo,
  mGLP: MagicGLPLogo,
  MIM: MIMLogo,
  MNT: MNTLogo,
  OKB: OKBLogo,
  PENDLE: PENDLELogo,
  plvGLP: plvGLP,
  PREMIA: PREMIALogo,
  'PT-eETH': PTweETHLogo,
  'PT-ezETH': PTezETHLogo,
  'PT-GLP': PTGLPLogo,
  'PT-mETH': PTmETHLogo,
  'PT-rETH': PTrETHLogo,
  'PT-rsETH': PTrsETHLogo,
  'PT-USDe': PTUSDeLogo,
  'PT-wstETH': PTwstETHLogo,
  PTSI: PTSILogo,
  RDNT: RDNTLogo,
  REP: REPLogo,
  rETH: rETHLogo,
  rsETH: rsETHLogo,
  sMNT: sMNTLogo,
  UNKNOWN: UNKNOKWNLogo,
  UNI: UNILogo,
  USDC: USDCLogo,
  'USDC.E': USDCLogo,
  'USDC.e': USDCLogo,
  USDe: USDeLogo,
  USDM: USDMLogo,
  USDT: USDTLogo,
  USDY: USDYLogo,
  vARB: ARBLogo,
  weETH: weETHLogo,
  WBERA: WBERALogo,
  WBTC: WBTCLogo,
  WETH: WETHLogo,
  WETH9: WETHLogo,
  WMATIC: WMATICLogo,
  WMNT: WMNTLogo,
  wOETH: wOETHLogo,
  WOKB: WOKBLogo,
  wstETH: wstETHLogo,
  wUSDM: wUSDMLogo,
  'YT-GLP': PTGLPLogo,
  XAI: XAILogo,
  ZRX: ZRXLogo,
}

function getLogoOrDefault(symbol) {
  return logos[symbol] || logos.UNKNOWN
}

const TitleSectionWrapper = styled.div`
  width: 100%;
  height: 100vh;
  min-height: 600px;
  overflow: hidden;
  background-color: #1e1c29;
  /*background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' heigt='100' viewBox='0 0 100 100'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%2340444f' fill-opacity='0.35'%3E%3Cpath opacity='.5' d='M96 95h4v1h-4v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9zm-1 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9z'/%3E%3Cpath d='M6 5V0H5v5H0v1h5v94h1V6h94V5H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");*/
  
  > div:nth-of-type(1) {
    width: /*calc(100% - 17px);*/ 100%;
    height: calc(100vh + 100px);
  }

  /*@media screen and (max-width: 880px) {
    height: 885px;
    
    > div:nth-of-type(1) {
      width: calc(100% - 40px);
      max-width: 480px;
    }
  }*/
  
  @media screen and (max-width: 700px) {
    height: calc(100vh + 300px);
  }
`

const FadeInLeftAnimation = keyframes`
  0% {
    /*transform: translateY(-30px);*/
    transform: translateX(-30px);
    opacity: 0;
  }
    100% {
    /*transform: translateY(0);*/
    transform: translateX(0);
    opacity: 1;
  }
`

const FadeInRightAnimation = keyframes`
  0% {
    transform: translateX(30px);
    opacity: 0;
  }
  65% {
    transform: translateX(30px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`

const FadeInAnimation = keyframes`
  0% {
    transform: translateY(-30px);
    opacity: 0;
  }
    100% {
    transform: translateY(0);
    opacity: 1;
  }
`

const TitleSectionInner = styled.div`
  max-width: 1480px;
  height: 100%;
  /*padding-left: 80px;*/
  /*width: calc(100% - 80px);*/
  margin: 0 auto;
  padding: 0 7.3%;
  width: 85.4%;
  
  /*@media screen and (max-width: 1100px) {
    width: calc(100% - 60px);
    padding-left: 60px;
  }*/
  
  /*@media screen and (max-width: 880px) {
    padding: 0 20px;
    width: calc(100% - 40px);
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
  }*/
`

const LeftSide = styled.div`
  display: inline-block;
  width: 50%;
  height: calc(100% - 35vh);
  min-height: 450px;
  vertical-align: top;
  color: #f9f9f9;
  animation: ${FadeInAnimation} 0.7s ease-out 0.2s both;
  
  @media screen and (max-width: 1000px) {
    height: calc(100% - 40vh);
    min-height: 400px;
  }
  
  /*@media screen and (max-width: 880px) {
    width: 100%;
    text-align: center;
    margin-top: 5vh;
    height: fit-content;
  }*/
  
  @media screen and (max-width: 880px) {
    width: 100%;
    height: calc(100% - 50vh);
    min-height: 200px;
    /*width: 100%;
    height: fit-content;
    position: relative;
    margin-top: 50vh;
    text-align: center;*/
  }
  
  @media screen and (max-width: 700px) {
    min-height: auto;
    height: fit-content;
    margin-top: calc(100vh - 460px);
  }
`

const LeftSideInner = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: flex-end;
  justify-content: left;
  position: relative;
  
  /*@media screen and (max-width: 880px) {
    position: absolute;
    z-index: 3;
  }*/
`

const LeftSideContent = styled.div`
  display: inline-block;
  height: fit-content;
  
  /*@media screen and (max-width: 880px) {
    max-width: 420px;
    margin: 0 auto;
  }*/
`

const TitleText = styled.div`
  display: inline-block;
  vertical-align: top;
  font-size: 4.2em;
  font-weight: 400;
  line-height: 1.1em;
  letter-spacing: 0.5px;
  width: 100%;
  margin-bottom: 20px;
  
  @media screen and (max-width: 1480px) {
    font-size: 3.6em;
  }
  
  @media screen and (max-width: 1200px) {
    font-size: 3em;
  }
  
  @media screen and (max-width: 1000px) {
    font-size: 2.7em;
  }
  
  @media screen and (max-width: 850px) {
    font-size: 2.4em;
  }
  
  @media screen and (max-width: 700px) {
    font-size: 2.2em;
  }
`

const SubtitleText = styled.div`
  display: inline-block;
  vertical-align: top;
  font-size: 1em;
  line-height: 1.5em;
  font-weight: 300;
  color: #d5d6e1;
  margin-bottom: 30px;
  letter-spacing: 0.3px;
  max-width: 550px;
  
  @media screen and (max-width: 1480px) {
    font-size: 0.9em;
  }

  @media screen and (max-width: 1200px) {
    font-size: 0.8em;
  }

  @media screen and (max-width: 1000px) {
    font-size: 0.7em;
  }
  
  @media screen and (max-width: 880px) {
    font-size: 11px;
    margin-bottom: 23px;
  }
`

const ActionButtons = styled.div`
  display: inline-block;
  vertical-align: top;
  width: 100%;
  text-align: left;

  a {
    text-decoration: none;
    color: inherit;
  }
    
  /*@media screen and (max-width: 880px) {
    text-align: center;
  }*/
`

const LaunchAppButton = styled.div`
  width: fit-content;
  padding: 12px 24px;
  background-color: #8fc942;
  border-radius: 5px;
  font-weight: 400;
  font-size: 16px;
  display: inline-block;
  margin-right: 20px;
  cursor: pointer;
  
  :hover {
    background-color: #a1db54;
  }
  
  @media screen and (max-width: 1200px) {
    font-size: 15px;
  }
  
  /*@media screen and (max-width: 1100px) {
    width: calc(100% - 48px);
    margin-bottom: 15px;
    margin-right: 0;
    text-align: center;
  }*/
  
  /*@media screen and (max-width: 880px) {
    margin-right: 0;
    min-width: 50%;
    font-size: 16px;
    padding: 10px 20px;
  }*/

  @media screen and (max-width: 700px) {
    width: calc(100% - 48px);
    text-align: center;
    margin-bottom: 10px;
  }
`

const QuickStartGuideButton = styled(LaunchAppButton)`
  background-color: #565A69;
  display: inline-block;
  
  :hover {
    background: #6C7284;
  }

  @media screen and (max-width: 1200px) {
    font-size: 15px;
  }
  
  /*@media screen and (max-width: 1100px) {
    width: calc(100% - 48px);
    text-align: center;
  }*/
  
  /*@media screen and (max-width: 880px) {
    margin-top: 12px;
  }*/
`

const GuideLink = styled(Link)`
  color: inherit;
  text-decoration: inherit;
`

const RightSide = styled.div`
  display: inline-block;
  width: 50%;
  height: calc(100% - 35vh);
  min-height: 450px;
  vertical-align: top;

  @media screen and (max-width: 1000px) {
    height: calc(100% - 40vh);
    min-height: 400px;
  }
  
  /*@media screen and (max-width: 1100px) {
    width: 59.8%;
  }*/
  
  /*@media screen and (max-width: 880px) {
    height: 40vh;
    margin-top: 10vh;
  }*/
  
  @media screen and (max-width: 880px) {
    width: 100%;
    height: 100px;
    min-height: auto;
    /*height: calc(120vh + 30px);*/
    /*height: 915px;
    position: absolute;
    top: -30px;
    width: 100%;
    z-index: 2;
    left: 0;*/
  }
  
  @media screen and (max-width: 700px) {
    height: fit-content;
  }
`

const DriftAnimation = keyframes`
  from {
    transform: translateX(0);
  }
  
  to {
    transform: translateX(calc(100vw - 100%));
    /*margin-left: -100%;*/
  }
`

const RightSideImageWrapper = styled.div`
  display: flex;
  justify-content: left;
  position: relative;
  margin-top: 110px;
  margin-left: 25px;
  height: 80%;
  
  img {
    width: auto;
    height: 100%;
    border-radius: 8px;
    box-shadow: 3px 7px 8px -2px rgb(0 0 0 / 50%), 4px 8px 21px 4px rgb(0 0 0 / 50%);
  }
  
  > div > img:nth-of-type(2) {
    display: none;
  }
  
  /*@media screen and (max-width: 880px) {
    margin-top: 0;
    margin-left: 50px;
  }*/
  
  @media screen and (max-width: 880px) {
    margin: 0;
    height: 100%;
    width: 100%;
    max-width: 100vw;
    overflow: hidden;
    position: relative;
    
    > div {
      width: fit-content;
      height: 100%;
      position: absolute;
      
      > img:nth-of-type(1) {
        display: none;
      }
      
      > img:nth-of-type(2) {
        display: block;
      }
    }
    
    img {
      height: 100%;
      width: auto;
      animation: ${DriftAnimation} 50s ease-out infinite alternate;
    }
  }
`

const PrimaryStats = styled.div`
  width: 100%;
  font-family: 'Open Sans', sans-serif;
  position: relative;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  height: 100%;
  
  @media screen and (max-width: 880px) {
    flex-direction: row;
  }
  
  @media screen and (max-width: 700px) {
    flex-direction: column;
    margin-top: 100px;
  }
`

const PrimaryStat = styled.div`
  width: 100%;
  text-align: right;
  color: #f9f9f9;
  margin-top: 30px;
  animation: ${FadeInRightAnimation} 1.5s ease-out 0s both;
  
  :nth-of-type(2) {
    animation: ${FadeInRightAnimation} 1.5s ease-out 0.2s both;
  }

  :nth-of-type(3) {
    animation: ${FadeInRightAnimation} 1.5s ease-out 0.4s both;
  }
  
  @media screen and (max-width: 1100px) {
    margin-top: 20px;
  }

  @media screen and (max-width: 880px) {
    margin-top: 40px;
    text-align: left;
  }

  @media screen and (max-width: 700px) {
    margin-top: 25px;
    text-align: center;
  }
`

const PrimaryStatTitle = styled.div`
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 1px;
  color: #d5d6e1;
  
  @media screen and (max-width: 1480px) {
    font-size: 16px;
  }

  @media screen and (max-width: 1200px) {
    font-size: 15px;
  }

  @media screen and (max-width: 1000px) {
    font-size: 13px;
  }

  /*@media screen and (max-width: 880px) {
    text-align: left;
  }*/

  @media screen and (max-width: 700px) {
    /*text-align: right;*/
    font-size: 15px;
  }
`

const Small = styled.span`
  font-size: 0.8em;
  margin-bottom: 0.2em;
`

const PrimaryStatValue = styled.div`
  font-size: 54px;
  font-weight: 300;
  display: flex;
  justify-content: flex-end;

  @media screen and (max-width: 1480px) {
    font-size: 48px;
  }

  @media screen and (max-width: 1200px) {
    font-size: 42px;
  }

  @media screen and (max-width: 1000px) {
    font-size: 36px;
  }

  @media screen and (max-width: 880px) {
    font-size: 28px;
    /*text-align: left;*/
  }

  @media screen and (max-width: 700px) {
    font-size: 36px;
    justify-content: center;
    /*text-align: right;*/
  }
`

const FadeIn = keyframes`
  0% {
    opacity: 0;
  }
    100% {
    opacity: 1;
  }
`

const HighlightedRatesWrapper = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  z-index: 9;
  top: calc(100vh - 95px);
  animation: ${FadeIn} 0.7s ease-out 2s both;
  
  @media screen and (max-height: 600px) {
    top: 540px;
  }

  /*@media screen and (max-width: 1000px) {
    top: 520px;
  }*/
  
  @media screen and (max-width: 700px) {
    top: calc(100vh - 150px);
  }
`

const HighlightedRates = styled.div`
  width: 4200px;
`

const HighlightedRate = styled.div`
  display: inline-block;
  vertical-align: top;
  width: fit-content;
  margin-right: 50px;
  margin-left: 50px;
  cursor: pointer;
  transition: transform 0.3s;
  
  :hover {
    transform: scale(1.1);
  }
`

const RateImage = styled.div`
  display: inline-block;
  vertical-align: top;
  height: 28px;
  margin-top: 5px;
  width: fit-content;
  
  img {
    height: 100%;
    width: auto;
  }
  
  @media screen and (max-width: 1000px) {
    height: 24px;
    margin-top: 4px;
  }
`

const RateData = styled.div`
  display: inline-block;
  vertical-align: top;
  margin-left: 10px;
`

const HighlightedRateTitle = styled.div`
  width: 100%;
  font-size: 16px;
  color: #f9f9f9;
  font-weight: 400;
  
  @media screen and (max-width: 1000px) {
    font-size: 14px;
  }
`

const HighlightedRateName = styled.div`
  font-size: 11px;
  color: #d5d6e1;
  font-weight: 300;
  margin-top: -3px;
  
  @media screen and (max-width: 1000px) {
    font-size: 10px;
  }
`

const HighlightedRateValue = styled.div`
  font-size: 36px;
  font-weight: 400;
  color: #8fc942; /*#68b04d;*/
  display: inline-block;
  vertical-align: top;
  margin-left: 10px;
  margin-top: -7px;
  
  @media screen and (max-width: 1000px) {
    font-size: 30px;
    margin-left: 8px;
    margin-top: -5px;
  }
`

const ApyText = styled.span`
  font-size: 0.5em;
  color: #d5d6e1;
  font-weight: 300;
  margin-left: -5px;

  @media screen and (max-width: 1000px) {
    font-size: 0.4em;
    margin-left: -4px;
  }
`

// -------

/*const HighlightedRatesTable = styled.div`
  width: calc(100% - 150px);
  border-radius: 8px;
  background-color: #2a2837;
  margin-top: 50px;
  padding: 50px 75px;
  box-shadow: 3px 7px 8px -2px rgb(0 0 0 / 50%), 4px 8px 21px 4px rgb(0 0 0 / 50%);
  color: #f9f9f9;
  position: relative;
  z-index: 9;
`

const HighlightedRatesTableName = styled.div`
  width: 40%;
`

const HighlightedRatesTableHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #6b6a76;
  
  // ${HighlightedRatesTableName} {
  //   margin-left: 45px;
  //   margin-right: -45px;
  // }
`

const RateImage = styled.div`
  display: inline-block;
  height: 30px;
  width: 30px;
  vertical-align: top;
  margin-right: 15px;
`

const HighlightedRatesTableYield = styled.div`
  width: 25%;
  text-align: right;
`

const HighlightedRatesTableSupply = styled.div`
  width: 30%;
  text-align: right;
`

const HighlightedRatesTableNetwork = styled.div`
  //color: ${({ network }) => (network ? network === 'Arbitrum' ? '#58afd8' : '#ff983b' : 'inherit')};
  width: 40%;
  text-align: right;
`

const HighlightedRatesTableRow = styled.div`
  width: 100%;
  margin-bottom: 15px;
  font-size: 20px;
  line-height: 30px;
  height: 40px;
  font-weight: 300;
  display: flex;
  justify-content: space-between;
  
  ${HighlightedRatesTableYield} {
    color: #68b04d;
    
    span {
      font-size: 0.7em;
      color: #d5d6e1;
    }
  }
`*/

const formatNumber = (num) => {
  return parseFloat(num).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const formatForAnimation = (numStr) => {
  const [whole, decimal] = numStr.split('.')
  return [parseInt(whole), parseInt(decimal?.substring(0, 2) ?? 0)]
}

// markup
const TitleSection = () => {
  const [width, setWidth] = useState(0)
  const [data, setData] = useState({
    supplyTvlUsd: '0',
    borrowTvlUsd: '0',
    tradeVolumeUsd: '0',
  })
  const [tokenData, setTokenData] = useState([])

  const fetchData = async () => {
    try {
      const response = await fetch('https://api.dolomite.io/metrics/all')
      const json = await response.json()
      setData(json.data)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const fetchArbitrumData = async () => {
    try {
      /*
      X_LAYER = 196,
      MANTLE = 5000,
      POLYGON_ZK_EVM = 1101,
      BASE = 8453,
       */
      const interestRateResponseArb = await fetch('https://api.dolomite.io/tokens/42161/interest-rates')
      const tokenResponseArb = await fetch('https://api.dolomite.io/tokens/42161')

      const interestRateResultArb = await interestRateResponseArb.json()
      const tokenResultArb = await tokenResponseArb.json()
      const transformedDataArb = interestRateResultArb.interestRates.map((item) => {
        const tokenData = tokenResultArb.tokens.find(token => token.id === item.token.tokenAddress)
        const supplyInterestRateApy = (Math.pow(((parseFloat(item.supplyInterestRate) / 365) + 1), 365) - 1) * 100
        const tokenSymbol = tokenData.cleanSymbol
        const tokenName = tokenData.cleanName
        const totalSupplyInterestRate = supplyInterestRateApy + ((parseFloat(item.totalSupplyInterestRate) - parseFloat(item.supplyInterestRate)) * 100)
        const totalBorrowInterestRate = (Math.pow(((parseFloat(item.totalBorrowInterestRate) / 365) + 1), 365) - 1) * 100
        const totalSupplyAmount = tokenData.supplyLiquidity
        const outsideSupplyLabels = item.outsideSupplyInterestRateParts.map(part => part.label)
        const network = 'Arbitrum'

        return {
          tokenSymbol,
          tokenName,
          totalSupplyInterestRate,
          totalBorrowInterestRate,
          outsideSupplyLabels,
          totalSupplyAmount,
          network,
        }
      })

      const interestRateResponseMnt = await fetch('https://api.dolomite.io/tokens/5000/interest-rates')
      const tokenResponseMnt = await fetch('https://api.dolomite.io/tokens/5000')

      const interestRateResultMnt = await interestRateResponseMnt.json()
      const tokenResultMnt = await tokenResponseMnt.json()
      const transformedDataMnt = interestRateResultMnt.interestRates.map((item) => {
        const tokenData = tokenResultMnt.tokens.find(token => token.id === item.token.tokenAddress)
        const supplyInterestRateApy = (Math.pow(((parseFloat(item.supplyInterestRate) / 365) + 1), 365) - 1) * 100
        const tokenSymbol = tokenData.cleanSymbol
        const tokenName = tokenData.cleanName
        const totalSupplyInterestRate = supplyInterestRateApy + ((parseFloat(item.totalSupplyInterestRate) - parseFloat(item.supplyInterestRate)) * 100)
        const totalBorrowInterestRate = (Math.pow(((parseFloat(item.totalBorrowInterestRate) / 365) + 1), 365) - 1) * 100
        const totalSupplyAmount = tokenData.supplyLiquidity
        const outsideSupplyLabels = item.outsideSupplyInterestRateParts.map(part => part.label)
        const network = 'Mantle'

        return {
          tokenSymbol,
          tokenName,
          totalSupplyInterestRate,
          totalBorrowInterestRate,
          outsideSupplyLabels,
          totalSupplyAmount,
          network,
        }
      })

      const interestRateResponseBera = await fetch('https://api.dolomite.io/tokens/80094/interest-rates')
      const tokenResponseBera = await fetch('https://api.dolomite.io/tokens/80094')

      const interestRateResultBera = await interestRateResponseBera.json()
      const tokenResultBera = await tokenResponseBera.json()
      const transformedDataBera = interestRateResultBera.interestRates.map((item) => {
        const tokenData = tokenResultBera.tokens.find(token => token.id === item.token.tokenAddress)
        const supplyInterestRateApy = (Math.pow(((parseFloat(item.supplyInterestRate) / 365) + 1), 365) - 1) * 100
        const tokenSymbol = tokenData.cleanSymbol
        const tokenName = tokenData.cleanName
        const totalSupplyInterestRate = supplyInterestRateApy + ((parseFloat(item.totalSupplyInterestRate) - parseFloat(item.supplyInterestRate)) * 100)
        const totalBorrowInterestRate = (Math.pow(((parseFloat(item.totalBorrowInterestRate) / 365) + 1), 365) - 1) * 100
        const totalSupplyAmount = tokenData.supplyLiquidity
        const outsideSupplyLabels = item.outsideSupplyInterestRateParts.map(part => part.label)
        const network = 'Berachain'

        return {
          tokenSymbol,
          tokenName,
          totalSupplyInterestRate,
          totalBorrowInterestRate,
          outsideSupplyLabels,
          totalSupplyAmount,
          network,
        }
      })

      const combinedData = transformedDataArb.concat(transformedDataMnt).concat(transformedDataBera)
      combinedData.sort((a, b) => b.totalSupplyInterestRate - a.totalSupplyInterestRate)
      setTokenData(combinedData)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  // useEffect to run fetchData on component mount and set interval
  useEffect(() => {
    fetchData() // Initial fetch
    fetchArbitrumData()
    const intervalId = setInterval(fetchData, 5000) // Fetch every 10 minutes
    const arbitrumInterval = setInterval(fetchArbitrumData, 20000)

    // Cleanup interval on component unmount
    return () => {
      clearInterval(intervalId)
      clearInterval(arbitrumInterval)
    }
  }, [])

  useEffect(() => {
    setWidth(window.innerWidth)

    window.addEventListener('resize', () => setWidth(window.innerWidth))
    return () => window.removeEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  const [supplied, suppliedDecimals] = formatForAnimation(data.supplyTvlUsd)
  const [borrowed, borrowedDecimals] = formatForAnimation(data.borrowTvlUsd)
  const [tradeVolume, tradeVolumeDecimals] = formatForAnimation(data.tradeVolumeUsd)

  return (
    <TitleSectionWrapper>
      {width > 700 ?
        <div id="polyContainer" className="polyContainer" style={{ position: 'absolute', zIndex: '0', minHeight: '700px' }}>
          <div id="polyOutput" className="polyContainer" style={{ height: '100%', width: '100%' }}>
          </div>
        </div>
        :
        <div id="polyContainer" className="polyContainer" style={{ position: 'absolute', zIndex: '0', minHeight: 'calc(100vh + 400px)' }}>
          <div id="polyOutput" className="polyContainer" style={{ height: '100%', width: '100%' }}>
          </div>
        </div>
      }
      <TitleSectionInner>
        <LeftSide>
          <LeftSideInner>
            <LeftSideContent>
              <TitleText>
                Get the most<br/>out of your assets
              </TitleText>
              <SubtitleText>
                Dolomite is the only lending and borrowing platform that can support over 1,000 unique assets. Lend, borrow, and earn on the most comprehensive DeFi platform without losing your DeFi-Native Rights.
              </SubtitleText>
              <ActionButtons>
                <a href={'https://app.dolomite.io'}>
                  <LaunchAppButton>
                    Launch App
                  </LaunchAppButton>
                </a>
                <a href={'https://docs.dolomite.io'}>
                  <QuickStartGuideButton>
                    Documentation
                  </QuickStartGuideButton>
                </a>
              </ActionButtons>
            </LeftSideContent>
          </LeftSideInner>
        </LeftSide>
        <RightSide>
          {/*<RightSideImageWrapper>
            <div>
              <img src={DolomiteDevicesHeaderImage} alt={'Dolomite Exchange'} />
              <img src={DolomiteDevicesHeaderImageBlurred} alt={'Dolomite Exchange'} />
            </div>
          </RightSideImageWrapper>*/}
          <PrimaryStats>
            <PrimaryStat>
              <PrimaryStatTitle>
                Total Supplied
              </PrimaryStatTitle>
              <PrimaryStatValue>
                <Small>$</Small><AnimatedNumbers
                includeComma
                config={{ tension: 89, friction: 20 }}
                animationType={"calm"}
                animateToNumber={supplied}
              />.<AnimatedNumbers
                includeComma
                config={{ tension: 89, friction: 20 }}
                animationType={"calm"}
                animateToNumber={suppliedDecimals}
              />{/*formatNumber(data.supplyTvlUsd)*/}
              </PrimaryStatValue>
            </PrimaryStat>
            <PrimaryStat>
              <PrimaryStatTitle>
                Total Borrowed
              </PrimaryStatTitle>
              <PrimaryStatValue>
                <Small>$</Small><AnimatedNumbers
                includeComma
                config={{ tension: 89, friction: 20 }}
                animationType={"calm"}
                animateToNumber={borrowed}
              />.<AnimatedNumbers
                includeComma
                config={{ tension: 89, friction: 20 }}
                animationType={"calm"}
                animateToNumber={borrowedDecimals}
              />{/*formatNumber(data.borrowTvlUsd)*/}
              </PrimaryStatValue>
            </PrimaryStat>
            <PrimaryStat>
              <PrimaryStatTitle>
                Total Trade Volume
              </PrimaryStatTitle>
              <PrimaryStatValue>
                <Small>$</Small><AnimatedNumbers
                includeComma
                config={{ tension: 89, friction: 20 }}
                //onStart={() => console.log("onStart")}
                //onFinish={() => console.log("onFinish")}
                animationType={"calm"}
                animateToNumber={tradeVolume}
              />.<AnimatedNumbers
                includeComma
                config={{ tension: 89, friction: 20 }}
                animationType={"calm"}
                animateToNumber={tradeVolumeDecimals}
              />{/*formatNumber(data.tradeVolumeUsd)*/}
              </PrimaryStatValue>
            </PrimaryStat>
          </PrimaryStats>
        </RightSide>
        <HighlightedRatesWrapper>
          {tokenData.length > 0 && <Ticker>
              {/*tokenData.slice(0,4).map((item, index) =>
                <HighlightedRate>
                  <RateImage><img src={index % 2 === 0 ? GMARB : GRAI} /></RateImage>
                  <RateData>
                    <HighlightedRateTitle>
                      {item.tokenSymbol}
                    </HighlightedRateTitle>
                    <HighlightedRateName>
                      {item.tokenName}
                    </HighlightedRateName>
                  </RateData>
                  <HighlightedRateValue>
                    {item.totalSupplyInterestRate.toFixed(2)}% <ApyText>APY</ApyText>
                  </HighlightedRateValue>
                </HighlightedRate>
              )*/() => <HighlightedRates>
              {tokenData.slice(0,10).map((item, index) =>
                <a href={'https://app.dolomite.io'} key={item.tokenSymbol}><HighlightedRate>
                  <RateImage><img src={getLogoOrDefault(item.tokenSymbol)} /></RateImage>
                  <RateData>
                    <HighlightedRateTitle>
                      {item.tokenSymbol}
                    </HighlightedRateTitle>
                    <HighlightedRateName>
                      {item.tokenName}
                    </HighlightedRateName>
                  </RateData>
                  <HighlightedRateValue>
                    {item.totalSupplyInterestRate.toFixed(2)}% <ApyText>APY</ApyText>
                  </HighlightedRateValue>
                </HighlightedRate></a>
              )}
              </HighlightedRates>}
          </Ticker>}
        </HighlightedRatesWrapper>
        {/*<HighlightedRatesTable>
          <HighlightedRatesTableHeader>
            <HighlightedRatesTableName>
              Asset
            </HighlightedRatesTableName>
            <HighlightedRatesTableYield>
              Supply Yield
            </HighlightedRatesTableYield>
            {/*<HighlightedRatesTableSupply>
              TVL
            </HighlightedRatesTableSupply>*/}
        {/*<HighlightedRatesTableNetwork>
              Chain
            </HighlightedRatesTableNetwork>
          </HighlightedRatesTableHeader>
          {tokenData.slice(0,6).map((item, index) =>
            <HighlightedRatesTableRow>
              <HighlightedRatesTableName>
                <RateImage><img src={index % 2 === 0 ? GMARB : GRAI} /></RateImage>
                {item.tokenSymbol} (add name below)
              </HighlightedRatesTableName>
              <HighlightedRatesTableYield>
                {item.totalSupplyInterestRate.toFixed(2)}% <span>APY</span> (add +Rewards below)
              </HighlightedRatesTableYield>
              {/*<HighlightedRatesTableSupply>
                <Small>$</Small>{formatNumber(item.totalSupplyAmount)} (change to token amount with USD below)
              </HighlightedRatesTableSupply>*/}
        {/*<HighlightedRatesTableNetwork network={item.network}>
                {item.network}
              </HighlightedRatesTableNetwork>
            </HighlightedRatesTableRow>
          )}
        </HighlightedRatesTable>*/}
      </TitleSectionInner>
    </TitleSectionWrapper>
  )
}

export default TitleSection
